export const UAState = {
  DISCONNECTED: 'DISCONNECTED',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  REGISTERED: 'REGISTERED',
  UNREGISTERED: 'UNREGISTERED',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
};

export const CallState = {
  IDLE: 'IDLE',
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  ON_HOLD: 'ON_HOLD',
  ENDED: 'ENDED',
};

export const VoIPError = {
  NO_MICROPHONE: 'NO_MICROPHONE',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  CONNECTION_FAILED: 'CONNECTION_FAILED',
  CALL_FAILED: 'CALL_FAILED',
  NO_EXTENSION: 'NO_EXTENSION',
};
